import { useEffect, useMemo, useState } from "react";
import { Products } from "../Products/Products";
import { ProductsMobNew } from "../Products/Mobile/ProductsMobNew";
import "./Home.scss";
import { ArrowsSlider } from "../Components/images/ArrowsSlider";
import { Mob_AutoSlider } from "../Components/images/Mob/AutoSlider";
import { AutoSlider } from "../Components/images/AutoSlider";
import emeraldStar from './assets/svg/star-emerald.svg'
import { isAndroid, isMobile } from 'react-device-detect';
import { fetchSiteMedia, mediaUrl } from '../utils/siteMedia';

const SECONDARY_KEYS = [
  'home.secondary.1',
  'home.secondary.2',
  'home.secondary.3',
  'home.secondary.4',
  'home.secondary.5',
  'home.secondary.6',
];
const SECONDARY_BADGES = [
  { title: '10% OFF', subtitle: 'Shop Now' },
  { title: 'New', subtitle: 'Shop Now' },
  { title: 'Bestseller', subtitle: 'Shop Now' },
  { title: '20% OFF', subtitle: 'Shop Now' },
  { title: 'Hot deal', subtitle: 'Shop Now' },
  { title: 'Limited', subtitle: 'Shop Now' },
];

export function Home() {
    const [assets, setAssets] = useState(null);

    useEffect(() => {
        let cancelled = false;
        fetchSiteMedia().then((map) => {
            if (!cancelled) setAssets(map || {});
        });
        return () => { cancelled = true; };
    }, []);

    const images = useMemo(() => {
        if (!assets) return [];
        return [
            mediaUrl(assets, 'home.hero.video') && {
                video: mediaUrl(assets, 'home.hero.video'),
                url: '/specific',
                cta: 'See it spin',
            },
            mediaUrl(assets, 'home.hero.1') && {
                img: mediaUrl(assets, 'home.hero.1'),
                url: '/specific',
                cta: 'Shop new drops',
            },
            mediaUrl(assets, 'home.hero.2') && {
                img: mediaUrl(assets, 'home.hero.2'),
                url: '/specific',
                cta: 'Find your fit',
            },
            mediaUrl(assets, 'home.hero.3') && {
                img: mediaUrl(assets, 'home.hero.3'),
                url: '/specific',
                cta: 'Explore bestsellers',
            },
        ].filter(Boolean);
    }, [assets]);

    const offerSlides = useMemo(() => {
        if (!assets) return [];
        return SECONDARY_KEYS
            .map((key, i) => {
                const img = mediaUrl(assets, key);
                return img ? { img, url: '/specific', badge: SECONDARY_BADGES[i] } : null;
            })
            .filter(Boolean);
    }, [assets]);

    return (
        <div className="home">
            <div className="content">
                <div className="innerContent">
                    <div className="inner2Content">
                        <div className="home-screen">
                            {images.length > 0 && (
                                <ArrowsSlider imagesToShow={1} images={images} />
                            )}
                        </div>
                    </div>
                </div>

                <div className="offers-banner offers-banner--underline">
                    <div className="offers-banner__center">
                        <div className="offers-banner__stars" aria-hidden="true">
                            <img src={emeraldStar} alt="" />
                            <img src={emeraldStar} alt="" />
                            <img src={emeraldStar} alt="" />
                        </div>
                        <div className="offers-banner__title">
                            <span className="offers-banner__eyebrow">TOP</span>
                            <span className="offers-banner__headline">OFFERS</span>
                        </div>
                        <div className="offers-banner__mark" aria-hidden="true">
                            <span className="offers-banner__mark-dot" />
                            <span className="offers-banner__mark-line" />
                            <span className="offers-banner__mark-dot" />
                        </div>
                    </div>
                </div>
                {assets && offerSlides.length > 0 && (
                    isMobile
                        ? <Mob_AutoSlider imagesToShow={3} images={offerSlides} />
                        : <AutoSlider imagesToShow={6} images={offerSlides} />
                )}

                {isMobile ? (
                    <ProductsMobNew mobileCardVariant={isAndroid ? 'translateStrip' : 'stacked'} />
                ) : (
                    <Products />
                )}

            </div>
        </div>
    )
}
